module.exports = __webpack_public_path__ + "5492a36c674976fb914b369a0ef71376.jpg";